export default {
  methods: {
    keyFunction (event, key, callback) {
      if (event.key === key) {
        callback(event)
      }
    }
  },
  created () {
    window.addEventListener('keydown', this.onKey)
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.onKey)
  }
}
